import { FETCH_FESTIVOS, GET_FESTIVOS, GET_FESTIVOS_FAIL } from "../actions/types.js";

const initialState = {
  festivos: [],
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_FESTIVOS:
      return {
        ...state,
        festivos: action.payload,
        isLoading: false,
      };
    case FETCH_FESTIVOS:
    case GET_FESTIVOS_FAIL:
      return {
        ...state,
        isLoading: true,
      };
    default:
      return state;
  }
}
